<template>
  <div class="p-6 min-w-min h-full flex flex-col bg-white rounded-2xl">
    <!-- title and search bar -->
    <div class="flex flex-row items-center justify-between">
      <p class="text-3xl font-bold">AAA-C Profile</p>
      <BaseRoundedButton @click="handleEdit">
        <p class="font-sans">Update Profile</p>
      </BaseRoundedButton>
    </div>
    <!-- body -->
    <div class="flex flex-row space-x-4 my-8">
      <div class="px-4">
        <div class="flex space-x-4">
          <div class="w-48">
            <p class="text-gray text-lg font-light">Header Logo</p>
            <img class="object-scale-down rounded-xl my-2" :src="headerLogo" alt="" />
          </div>
          <div class="w-48">
            <p class="text-gray text-lg font-light">Logo</p>
            <img class="object-scale-down rounded-xl my-2" :src="logo" alt="" />
          </div>
        </div>
        <div class="">
          <p class="text-gray text-lg font-light">Cover Image</p>
          <img class="object-cover rounded-xl my-2 rectangle_img" :src="cover" alt="" />
        </div>
      </div>
      <div class="w-1/2 bg-light-gray rounded-2xl p-4 space-y-4">
        <p class="text-gray text-lg font-light">Profile Detail</p>
        <div class="space-y-2">
          <div>
            <p class="text-gray text-lg font-light">Description</p>
            <p class="text-blue text-lg font-medium">{{ this.description }}</p>
          </div>
          <div>
            <p class="text-gray text-lg font-light">Address</p>
            <p class="text-blue text-lg font-medium">{{ this.address }}</p>
          </div>
          <div>
            <p class="text-gray text-lg font-light">Phone Number 1</p>
            <p class="text-blue text-lg font-medium">{{ this.phone1 }}</p>
          </div>
          <div>
            <p class="text-gray text-lg font-light">Phone Number 2</p>
            <p class="text-blue text-lg font-medium">{{ this.phone2 }}</p>
          </div>
          <div v-if="this.phone3 == !null">
            <p class="text-gray text-lg font-light">Phone Number 3</p>
            <p class="text-blue text-lg font-medium">{{ this.phone3 }}</p>
          </div>
          <div v-if="this.phone3 == !null">
            <p class="text-gray text-lg font-light">Phone Number 4</p>
            <p class="text-blue text-lg font-medium">{{ this.phone4 }}</p>
          </div>
          <div>
            <p class="text-gray text-lg font-light">Email</p>
            <p class="text-blue text-lg font-medium">{{ this.email }}</p>
          </div>
          <div>
            <p class="text-gray text-lg font-light">Facebook</p>
            <p class="text-blue text-lg font-medium">
              {{ this.socialMedias.facebook }}
            </p>
          </div>
          <div>
            <p class="text-gray text-lg font-light">LinkedIn</p>
            <p class="text-blue text-lg font-medium">
              {{ this.socialMedias.linkedin }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <SideBar v-show="showUpdateSideBar" @close-modal="handleEdit">
    <div class="w-full h-full flex flex-col content-between">
      <!-- header -->
      <h1 class="text-blue text-2xl">Update Profile</h1>
      <!-- body -->
      <div class="flex flex-col space-y-2 mb-8">
        <div>
          <!-- header logo -->
          <div @click="handleFileImport" class="group py-4 cursor-pointer relative">
            <p class="text-gray mb-2 font-normal">Header Logo</p>
            <!-- hiddden image file input field that triger when profile image container clicked -->
            <input ref="headerLogoUploader" class="hidden" type="file" name="profileImage" id="profileImage"
              accept="image/*" @change="handleFileUpload($event)" />
            <div class="flex justify-center">
              <img v-if="headerLogo" class="w-full rectangle_img object-scale-down rounded-lg mb-2" :src="headerLogo"
                alt="" />
              <img v-else class="w-full rectangle_img object-cover rounded-lg mb-2"
                src="https://www.berchielli.co.uk/wp-content/themes/barberry/images/placeholder.jpg" alt="" />
            </div>
            <p v-if="headerLogo" class="
                cursor-pointer
                text-center text-lg
                font-sans
                text-blue
                group-hover:underline
              ">
              Change header logo
            </p>
            <p v-else class="
                cursor-pointer
                text-center text-lg
                font-sans
                text-blue
                group-hover:underline
              ">
              Add header logo
            </p>
          </div>
          <!-- logo -->
          <div @click="handleLogoImport" class="group py-4 cursor-pointer relative">
            <p class="text-gray mb-2 font-normal">Logo</p>
            <!-- hiddden image file input field that triger when profile image container clicked -->
            <input ref="logoUploader" class="hidden" type="file" name="logoImage" id="logoImage" accept="image/*"
              @change="handleLogoUpload($event)" />
            <div class="flex justify-center">
              <img v-if="logo" class="w-full rectangle_img object-scale-down rounded-lg mb-2" :src="logo" alt="" />
              <img v-else class="w-full rectangle_img object-cover rounded-lg mb-2"
                src="https://www.berchielli.co.uk/wp-content/themes/barberry/images/placeholder.jpg" alt="" />
            </div>
            <p v-if="logo" class="
                cursor-pointer
                text-center text-lg
                font-sans
                text-blue
                group-hover:underline
              ">
              Change logo
            </p>
            <p v-else class="
                cursor-pointer
                text-center text-lg
                font-sans
                text-blue
                group-hover:underline
              ">
              Add logo
            </p>
          </div>
          <!-- cover -->
          <div @click="handleCoverImport" class="group py-4 cursor-pointer relative">
            <p class="text-gray mb-2 font-normal">Cover Image</p>
            <!-- hiddden image file input field that triger when profile image container clicked -->
            <input ref="coverUploader" class="hidden" type="file" name="logoImage" id="logoImage" accept="image/*"
              @change="handleCoverUpload($event)" />
            <div class="flex justify-center">
              <img v-if="cover" class="w-full rectangle_img object-scale-down rounded-lg mb-2" :src="cover" alt="" />
              <img v-else class="w-full rectangle_img object-cover rounded-lg mb-2"
                src="https://www.berchielli.co.uk/wp-content/themes/barberry/images/placeholder.jpg" alt="" />
            </div>
            <p v-if="cover" class="
                cursor-pointer
                text-center text-lg
                font-sans
                text-blue
                group-hover:underline
              ">
              Change cover image
            </p>
            <p v-else class="
                cursor-pointer
                text-center text-lg
                font-sans
                text-blue
                group-hover:underline
              ">
              Add cover image
            </p>
          </div>
        </div>
        <base-text-input v-model="name" name="name" isAutoComplete="off" label="Name" />
        <base-text-input v-model="description" name="description" isAutoComplete="off" label="Description" />
        <base-text-input v-model="address" name="address" isAutoComplete="off" label="Address" />
        <base-text-input v-model="email" name="email" isAutoComplete="off" label="Email" />
        <base-text-input v-model="phone1" name="phone1" isAutoComplete="off" label="Phone Number 1" />
        <base-text-input v-model="phone2" name="phone2" isAutoComplete="off" label="Phone Number 2" />
        <base-text-input v-model="phone3" name="phone3" isAutoComplete="off" label="Phone Number 3" />
        <base-text-input v-model="phone4" name="phone4" isAutoComplete="off" label="Phone Number 4" />
        <base-text-input v-model="socialMedias.facebook" name="facebook" label="Facebook URL" />
        <base-text-input v-model="socialMedias.linkedin" name="linkedin" label="LinkedIn URL" />
      </div>
      <!-- action button -->
      <div class="
          flex flex-row
          items-center
          justify-between
          space-x-4
          mt-auto
          pb-8
        ">
        <BaseRoundedButton @click="handleEdit" class="bg-dark-gray w-2/6">
          <p>Cancel</p>
        </BaseRoundedButton>
        <BaseRoundedButton @click="handleSaveUpdate" class="w-4/6">
          <p>Save Update</p>
        </BaseRoundedButton>
      </div>
    </div>
  </SideBar>
</template>


<script>
import BaseRoundedButton from "../components/BaseRoundedButton.vue";
import SideBar from "../components/SideBar.vue";
import userService from "../Services/user.service";
import BaseTextInput from "../components/BaseTextInput.vue";
import { useToast } from "vue-toastification";
export default {
  name: "AAACProfile",
  components: { BaseRoundedButton, SideBar, BaseTextInput },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      showUpdateSideBar: false,
      name: "",
      headerLogo: "",
      headerLogoFile: "",
      logo: "",
      logoFile: "",
      cover: "",
      coverFile: "",
      description: "",
      address: "",
      phone1: "",
      phone2: "",
      phone3: "",
      phone4: "",
      email: "",
      socialMedias: {
        facebook: "",
        linkedin: "",
      },
    };
  },
  methods: {
    getAAACProfile() {
      userService.getPorfile().then((response) => {
        this.name = response.data.data.name;
        this.headerLogo = response.data.data.header_logo;
        this.logo = response.data.data.logo;
        this.cover = response.data.data.cover;
        this.description = response.data.data.description;
        this.address = response.data.data.address;
        this.phone1 = response.data.data.phone_number_1;
        this.phone2 = response.data.data.phone_number_2;
        this.phone3 = response.data.data.phone_number_3;
        this.phone4 = response.data.data.phone_number_4;
        this.email = response.data.data.email;
        this.socialMedias.facebook = response.data.data.social_link[0].url;
        this.socialMedias.linkedin = response.data.data.social_link[1].url;
      });
    },

    handleEdit() {
      this.showUpdateSideBar = !this.showUpdateSideBar;
    },

    handleFileImport() {
      this.$refs.headerLogoUploader.click();
    },
    handleFileUpload(event) {
      this.headerLogoFile = event.target.files[0];
      this.headerLogo = URL.createObjectURL(this.headerLogoFile);
    },
    handleLogoImport() {
      this.$refs.logoUploader.click();
    },
    handleLogoUpload(event) {
      this.logoFile = event.target.files[0];
      this.logo = URL.createObjectURL(this.logoFile);
    },
    handleClearImage() {
      this.headerLogo = "";
      this.headerLogoFile = "";
    },
    handleCoverImport() {
      this.$refs.coverUploader.click();
    },
    handleCoverUpload(event) {
      this.coverFile = event.target.files[0];
      this.cover = URL.createObjectURL(this.coverFile);
    },
    handleClearCover() {
      this.cover = "";
      this.coverFile = "";
    },

    handleSaveUpdate() {
      this.$Progress.start();
      let formData = new FormData();
      formData.append("name", this.name);
      if (this.headerLogoFile || !this.headerLogo) {
        formData.append("header_logo", this.headerLogoFile);
      }
      if (this.logoFile || !this.logo) {
        formData.append("logo", this.logoFile);
      } if (this.coverFile || !this.cover) {
        formData.append("cover", this.coverFile);
      }
      formData.append("description", this.description);
      formData.append("address", this.address);
      formData.append("phone_number_1", this.phone1);
      formData.append("phone_number_2", this.phone2);
      formData.append("phone_number_3", this.phone3);
      formData.append("phone_number_4", this.phone4);
      formData.append("email", this.email);
      formData.append("social_medias", JSON.stringify(this.socialMedias));

      userService
        .storeUpdateProfile(formData)
        .then(() => {
          this.$Progress.finish();
          this.getAAACProfile();
          this.getOragnizationProfile();
          this.showUpdateSideBar = false;
          this.toast.success("Update profile successful.");
        })
        .catch((error) => {
          console.log(error);
          this.$Progress.fail();
          this.toast.error("Error! Cannot update profile!");
        });
    },
    getOragnizationProfile() {
      userService.getPorfile().then((response) => {
        this.$store.commit("setHeaderLogo", response.data.data.header_logo);
      });
    },
  },
  created() {
    this.$Progress.start();
    this.getAAACProfile();
  },
  mounted() {
    this.$Progress.finish();
  },
};
</script>

<style scoped>
.rectangle_img {
  aspect-ratio: 16/9;
}
</style>
